module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_25.dot-a9cbd15512c0b1bac0c466932b53271e.svg";